import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Checkbox, Select } from '@studio/legacy-components';
import { SelectOptionsShape } from 'next/lib/shapes';
import { selectExperienceOptionsForApp } from 'next/lib/selectors-options';
import useToggle from 'next/hooks/use-toggle';

import { OptionWrapper } from './styled';

export const TriggerAction = ({ options = [], onSave, nextContentId = '' }) => {
  const [draftValue, setDraftValue] = useState(nextContentId);
  const [showTriggerSelect, toggleShowTriggerSelect] = useToggle(
    !!nextContentId
  );
  const showTriggerAction = showTriggerSelect || !!draftValue;

  const handleClickTriggerCheckbox = () => {
    if (showTriggerAction) {
      onSave({ nextContentId: null });
      setDraftValue(null);
    }
    toggleShowTriggerSelect();
  };

  const handleSave = value => {
    onSave({ nextContentId: value });
    setDraftValue(value);
  };

  return (
    <OptionWrapper>
      <Checkbox
        checked={showTriggerAction}
        onChange={handleClickTriggerCheckbox}
      >
        Trigger Appcues content
      </Checkbox>
      {showTriggerSelect && (
        <Select
          aria-label="Select triggered Appcues content"
          kind="default"
          onChange={({ value }) => handleSave(value)}
          options={options}
          placeholder="Select a Flow"
          value={options.find(({ value }) => draftValue === value)}
        />
      )}
    </OptionWrapper>
  );
};

TriggerAction.propTypes = {
  options: SelectOptionsShape,
  onSave: PropTypes.func,
  nextContentId: PropTypes.string,
};

const mapStateToProps = (state, { appId = '', id = '' }) => {
  const options = selectExperienceOptionsForApp(state, appId).filter(
    ({ value }) => value !== id
  );

  return {
    options,
  };
};

export default connect(mapStateToProps)(TriggerAction);
